import React from 'react';
import { FaPlus } from 'react-icons/fa';

const ReportHeader = ({
  showAddButton = true,
  statusFilter = 0,
  onAddNew,
  addButtonLabel = 'Add New Report',
  children,
}) => {
  return (
    <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mt-6 mb-4">
      <div className="flex items-center gap-3">
        {showAddButton && statusFilter === 0 && onAddNew && (
          <button
            type="button"
            onClick={onAddNew}
            className="inline-flex items-center gap-1.5 px-3.5 py-2 text-xs font-semibold text-white bg-aimhi-textlight-neutral hover:bg-[#344759] rounded-lg shadow-sm transition-all cursor-pointer active:scale-[0.98]"
          >
            <FaPlus className="text-[10px]" />
            <span>{addButtonLabel}</span>
          </button>
        )}
        {children}
      </div>
    </div>
  );
};

export default ReportHeader;
